import React from 'react';
import PropTypes from 'prop-types';
import './ChordList.css';
import ChordItem from './ChordItem';

function ChordList({ chords, numOfChords, playChords, isShowingAnswer }) {

	return (
		<div className="ChordList-box box">
			{chords.map((chord, index) => (
				<ChordItem
					className={`button-${index}`}
					key={index}
					chord={chord}
					isShowingAnswer={isShowingAnswer}	
					playChords={playChords}
					/>
			))}
		</div>
	)
}
ChordList.propTypes = {
	chords: PropTypes.array.isRequired,
	numOfChords: PropTypes.number.isRequired,
}

export default ChordList;
